import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ApiUsuarioService } from '../services/api-usuario.service';

@Injectable({
  providedIn: 'root'
})
export class ActionGuard {

  constructor(private apiUsuario: ApiUsuarioService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.verificaStatus();
  }

  private verificaStatus(): Observable<UrlTree> | boolean {
    const licenca = this.apiUsuario.verificaLicenca();

    if (!this.licencaVencida(licenca)) {
      return true;
    }

    return this.apiUsuario.permissoesCarregadas$.pipe(
      filter(carregou => carregou),
      take(1),
      map(() => this.destinoLicencaVencida())
    );
  }

  private licencaVencida(licenca: any): boolean {
    const statusBloqueado = licenca?.status == 2 || licenca?.status == 3;
    return licenca?.prazoHoras < 0 || (statusBloqueado && !licenca?.periodoTeste);
  }

  private destinoLicencaVencida(): UrlTree {
    const idPermissaoPagamento = this.apiUsuario.permissoesCorretora?.PAGAMENTO?.id;
    const permissoesUsuario = this.apiUsuario.grupoPermissoesUsuario()?.permissoes ?? [];
    const acessaMeuPlano = !!idPermissaoPagamento && permissoesUsuario.includes(idPermissaoPagamento);

    return this.router.createUrlTree([acessaMeuPlano ? '/meu-plano' : '/pagina-indisponivel']);
  }
}
